import { Hit } from "react-instantsearch-core";
import { hitsPerPage } from "./constants";

export function track(
  eventName: string,
  props: {} = {},
  callbackFunction: () => void = () => null
) {
  let eventProps = {
    affiliation: "marketing",
    page_url: typeof window !== `undefined` ? window.location.href : null,
    ...props,
  };

  typeof window !== `undefined` &&
    window.analytics &&
    window.analytics.track(eventName, eventProps, {}, callbackFunction);
}

export function identifyEmail(email: string) {
  if (typeof window !== `undefined` && window.analytics) {
    const user = window.analytics.user().traits() as any;
    email && window.analytics.identify({ ...user, email });
  }
}

export function identify(traits: object) {
  if (typeof window !== `undefined` && window.analytics) {
    traits && window.analytics.identify(traits);
  }
}

// all parameters should be zero based
export function trackSearchResultClicked(
  recordName: string | undefined,
  index: string,
  query: string,
  hit: Pick<Hit, "objectID">,
  queryID: string | undefined,
  page: number,
  resultType: "page" | "autocomplete" | "noSearch",
  positionWithinPage: number
) {
  // multiple properties required for algolia insights: https://segment.com/docs/connections/destinations/catalog/algolia-insights/#track
  // algolia assumes 1-based numbers
  track("Clicked Search Result", {
    index: index,
    objectID: hit.objectID,
    queryID: queryID,
    position: page * hitsPerPage + (positionWithinPage + 1),
    recordName: recordName,
    query: query,
    page: page + 1,
    resultType: resultType,
  });
}
